export default {
  meta: {
    title: '资源管理-编辑'
  }
};
